import { ButtonHTMLAttributes, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { useCommonStore } from '@/store';

import { ScWheelButton } from './styled';
import { Spinner } from '@/styles/common';

interface WheelButtonProps {
  invert: boolean;
  isSpinning: boolean;
  isLoading: boolean;
}

export const WheelButton: FC<
  ButtonHTMLAttributes<HTMLButtonElement> & WheelButtonProps
> = ({ invert, isSpinning, isLoading, ...props }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation(['common', 'wheel']);
  const { blackColor, mainColor } = useTheme();

  const isAuthenticated = useCommonStore.use.isAuthenticated();

  return (
    <ScWheelButton
      {...props}
      isSpinning={isSpinning}
      disabled={isSpinning}
      isAuth={isAuthenticated}
      lng={language}
    >
      {isLoading ? (
        <Spinner size={60} center color={mainColor} background={blackColor} />
      ) : (
        <p className="message">
          {!isAuthenticated
            ? t('common:button.register')
            : invert
              ? t('wheel:buySpin')
              : t('wheel:spin')}
        </p>
      )}
    </ScWheelButton>
  );
};
